import { ItemCollection } from "../dto/item/ItemCollection";
export default class CheckAvailabilityEvent {
    constructor() {
        this.currency = 'EUR';
        this.itemCollection = new ItemCollection();
    }
    export() {
        return {
            currency: this.currency,
            items: this.itemCollection.export(),
        };
    }
}
